// extracted by mini-css-extract-plugin
export default {"container":"prerequisite_container__notne","content":"prerequisite_content__jnpbc","cardContainer":"prerequisite_cardContainer__q1C+o"};